import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerreportComponent } from './customerreport.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CustomerreportRoutingModule } from './customer-routing.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  declarations: [CustomerreportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CustomerreportRoutingModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomerreportModule { }
